<template>
  <button
    class="tei-button"
    :disabled="disabled"
    :class="[
      `tei-button--${color}`,
      {
        [`tei-button--${state}`]: state,
        'tei-button--text': text,
        'tei-button--small': small,
      }
    ]"
    @click="$emit('click', $event)"
  >
    <span
      v-if="text"
      class="tei-button__text"
    >
      {{ text }}
    </span>
    <NebulaIcon
      v-if="iconRight"
      class="tei-button__icon"
      :symbol-id="iconRight"
    />
    <slot />
  </button>
</template>

<script>
import { NebulaIcon } from '@discoveryedu/nebula-components';

export default {
  name: 'TEIButton',
  components: {
    NebulaIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    iconRight: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary', // primary, secondary
    },
    state: {
      type: String,
      default: null, // active
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};
</script>

<style lang="stylus">
@import './styles/tei-fonts';

.tei-button {
  tei-mikado-body-secondary-bold();

  align-items: center;
  border: 5px solid $nebula-color-white;
  border-radius: $nebula-border-radius-large;
  box-shadow: var(--tei-button-box-shadow);
  color: $nebula-color-white;
  display: inline-flex;
  gap: $nebula-space-1x;
  height: $nebula-space-9x + 1px;
  justify-content: center;
  margin: 0;
  max-width: 250px;
  min-width: $nebula-space-9x;
  padding: 0 $nebula-space-2x;
  transition: background-color $nebula-transition-default;

  &--text {
    min-width: 180px;
  }

  * {
    transition: opacity $nebula-transition-default;
  }

  &--primary {
    background-color: var(--tei-button-primary-color);

    &:hover, &:focus {
      background-color: var(--tei-button-primary-hover-color);
    }

    &:active {
      background-color: var(--tei-button-primary-active-color);
    }

    &:disabled {
      background-color: var(--tei-button-primary-disabled-color);
    }

    &.tei-button--active {
      background-color: var(--tei-button-primary-active-color);
    }
  }

  &--secondary {
    background-color: var(--tei-button-secondary-color);

    &:hover, &:focus {
      background-color: var(--tei-button-secondary-hover-color);
    }

    &:active {
      background-color: var(--tei-button-secondary-active-color);
    }

    &:disabled {
      background-color: var(--tei-button-secondary-disabled-color);
    }

    &.tei-button--active {
      background-color: var(--tei-button-secondary-active-color);
    }
  }

  &--neutral {
    background-color: var(--tei-button-neutral-color);
    border-color: $nebula-color-platform-neutral-1000;
    color: $nebula-color-platform-neutral-900;

    &:hover, &:focus {
      border-color: var(--tei-button-neutral-hover-color);
    }

    &:active {
      border-color: var(--tei-button-neutral-active-color);
    }

    &.tei-button--active {
      border-color: var(--tei-button-neutral-active-color);
    }

    .tei-layout-container__button-icon {
      fill: $nebula-color-platform-neutral-900;
    }
  }

  &--small {
    border-radius: 16px;
    border-width: 3px;
    height: 40px;
    min-width: 172px;
  }

  &__icon {
    flex: 0 0 auto;
    height: 30px;
    width: 30px;
  }

  svg {
    fill: $nebula-color-white;
  }
}
</style>
